// JSON-LD schema builders per entity
const BASE = 'https://learndunia.com';

export const buildBlogSchema = (blog, author) => ({
  '@context': 'https://schema.org',
  '@type': 'BlogPosting',
  headline: blog.title,
  description: blog.excerpt,
  image: blog.og_image || blog.image,
  datePublished: blog.date,
  dateModified: blog.date,
  author: author
    ? { '@type': 'Person', name: author.name, url: `${BASE}/author/${author.slug}` }
    : { '@type': 'Person', name: blog.author || 'Learndunia Editorial' },
  publisher: {
    '@type': 'Organization',
    name: 'Learndunia',
    logo: { '@type': 'ImageObject', url: `${BASE}/favicon.ico` },
  },
  mainEntityOfPage: { '@type': 'WebPage', '@id': `${BASE}/blog/${blog.slug || blog.id}` },
});

export const buildCollegeSchema = (c) => ({
  '@context': 'https://schema.org',
  '@type': 'CollegeOrUniversity',
  name: c.name,
  alternateName: c.short,
  description: c.about,
  image: c.og_image || c.image,
  foundingDate: String(c.established || ''),
  address: {
    '@type': 'PostalAddress',
    streetAddress: c.location,
    addressLocality: c.city,
    addressRegion: c.state,
    addressCountry: 'IN',
  },
  aggregateRating: c.rating ? { '@type': 'AggregateRating', ratingValue: c.rating, reviewCount: c.reviews || 1 } : undefined,
  url: `${BASE}/colleges/${c.slug || c.id}`,
});

export const buildUniversitySchema = (u) => ({
  '@context': 'https://schema.org',
  '@type': 'CollegeOrUniversity',
  name: u.name,
  description: `${u.type} University established in ${u.established}. NAAC ${u.naac}.`,
  image: u.og_image || u.image,
  foundingDate: String(u.established || ''),
  address: { '@type': 'PostalAddress', addressLocality: u.location, addressCountry: 'IN' },
  aggregateRating: u.rating ? { '@type': 'AggregateRating', ratingValue: u.rating, reviewCount: 1 } : undefined,
  url: `${BASE}/universities/${u.slug || u.id}`,
});

export const buildCourseSchema = (c) => ({
  '@context': 'https://schema.org',
  '@type': 'Course',
  name: c.name,
  description: c.description,
  provider: { '@type': 'Organization', name: 'Learndunia', sameAs: BASE },
  educationalLevel: c.stream,
  timeRequired: c.duration,
  url: `${BASE}/courses/${c.slug || c.id}`,
});

export const buildExamSchema = (e) => ({
  '@context': 'https://schema.org',
  '@type': 'EducationEvent',
  name: e.name,
  description: e.description,
  image: e.og_image || e.image,
  eventAttendanceMode: e.mode === 'Online' ? 'https://schema.org/OnlineEventAttendanceMode' : 'https://schema.org/OfflineEventAttendanceMode',
  organizer: { '@type': 'Organization', name: 'Learndunia', url: BASE },
  url: `${BASE}/exams/${e.slug || e.id}`,
  startDate: e.nextDate,
});

export const buildAuthorSchema = (a) => ({
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: a.name,
  description: a.bio,
  image: a.avatar,
  jobTitle: a.designation,
  email: a.email,
  sameAs: [
    a.twitter ? `https://twitter.com/${a.twitter}` : null,
    a.linkedin ? `https://linkedin.com/in/${a.linkedin}` : null,
    a.website || null,
  ].filter(Boolean),
  url: `${BASE}/author/${a.slug}`,
});
